import { useEffect, useContext } from 'react';
import { ConfigContext } from 'index';
import { useSelector } from 'react-redux';
import localStorageService from 'services/localStorage';
import { getConfigData } from 'redux/selectors/global';
import { usePageToken } from './usePageToken';
import { useActions } from './useActions';

export const useConfig = (...initFns) => {
  const config = useContext(ConfigContext);

  const { setConfigData } = useActions();
  const configData = useSelector(getConfigData);

  const pageToken = usePageToken();

  useEffect(() => {
    const loadConfig = async () => {
      localStorageService.setItem('baseUrl', config.base_url);
      setConfigData(config);

      await Promise.all(initFns.map(cb => cb(config, pageToken)));
    };

    loadConfig();
  }, [config]);

  return configData;
};
